import PropTypes from 'prop-types';
import React, { Component } from 'react';
import twttr from 'twitter-text';

import ReduxConnect from 'Demora/redux-connect';

class ReactTwitterText extends Component {
	constructor(props) {
		super();

		this.state = {
			showMoreOpen: false,
			text: [],
		};
	}

	convertText(t) {
		if (!t) {
			return null;
		}

		const { twitterURLEntities, twitterTextOptions } = this.props;

		const options = Object.assign({}, twitterTextOptions);

		let that = this;

		options.linkTextBlock = function (entity, text) {
			if (!entity.screenName) {
				return text;
			}

			let users = Object.keys(that.props.users);

			for (let i = 0; i < users.length; i++) {
				let u = that.props.users[users[i]];

				if (u && u.username && u.username == text) {
					return u.first_name + ' ' + u.last_name;
				}
			}

			return text;
		};

		t = t.replace(/\n/g, '<br />');

		t = twttr.autoLink(t, {
			...options,
			urlEntities: twitterURLEntities,
		});

		return t;
	}

	handleTweetTextLinkClick = (event) => {
		event.preventDefault();

		let eventTarget = event.target;

		if (event.target.nodeName === 'SPAN') {
			eventTarget = event.target.parentNode;
		}

		if (eventTarget.nodeName === 'A') {
			this.props.redirectCallback(eventTarget.href);
		}
	};

	handleShowMore = (sh, event) => {
		event.preventDefault();

		if (sh) {
			const ce = new CustomEvent('react_social_click_on_see_more', {
				view: window,
				bubbles: true,
				detail: {
					pid: this.props.post.h,
				},
			});

			document.dispatchEvent(ce);
		}

		this.setState({
			showMoreOpen: sh,
		});
	};

	render() {
		const { post, tweetText } = this.props;

		const maxLength = 200;

		const text = [];

		const t = tweetText;

		text[0] = t;

		if (t.length > maxLength) {
			const t1 = t.substr(0, maxLength);

			const lastSpace =
				t1.lastIndexOf(' ') === -1 ? t1.length : t1.lastIndexOf(' ');

			text[0] = t.substr(0, Math.min(t1.length, lastSpace));
			text[1] = t.substr(text[0].length + 1);
		}

		text[0] = this.convertText(text[0]);
		text[1] = this.convertText(text[1]);

		return (
			<p>
				<span
					key={text[0]}
					onClick={this.handleTweetTextLinkClick}
					dangerouslySetInnerHTML={{ __html: text[0] }}
				/>
				{!!text[1] &&
					(this.state.showMoreOpen ? (
						<span>
							<span
								onClick={this.handleTweetTextLinkClick}
								key={text[1]}
								dangerouslySetInnerHTML={{ __html: ' ' + text[1] }}
							/>{' '}
							<a
								href='#'
								onClick={(e) => this.handleShowMore(false, e)}
								style={{ color: '#1d2129', float: 'right' }}
							>
								(See less)
							</a>
						</span>
					) : (
						<span>
							...{' '}
							<a
								href='#'
								onClick={(e) => this.handleShowMore(true, e)}
								style={{ color: '#1d2129' }}
							>
								See more
							</a>
						</span>
					))}
			</p>
		);
	}
}

ReactTwitterText.propTypes = {
	redirectCallback: PropTypes.func,
	twitterTextOptions: PropTypes.object,
	twitterURLEntities: PropTypes.array,
};

export default ReduxConnect(ReactTwitterText, {
	users: 'users',
});
